/* eslint-disable */
export default {
  confirmation: 'Confirmation',
  confirmMergeToConference: 'Add to conference call?',
  mergeToConference: 'Merge',
  conferenceCall: 'Conference Call',
} as const;

// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
